import { Infer, t } from 'typegate';
import { LineOfBusinessName } from '../linesOfBusiness';
import { ApplicationType } from './applicationType';

import { ApplicationModes } from '@zinnia/form-engine-sdk';

export const createApplicationPayload = t
  .object(
    t.property('leadId', t.number),
    t.property('type', t.enum(ApplicationType)),
    t.property('mode', t.enum(ApplicationModes)),
    t.property('lineOfBusiness', t.enum(LineOfBusinessName)),
    t.property('questionnaireId', t.string),
    t.optionalProperty('mgaId', t.string),
    t.optionalProperty('userId', t.string),
  )
  .setTypeName('CreateApplicationPayload');

export type CreateApplicationPayload = Infer<typeof createApplicationPayload>;
